import React from "react";
import {
  Box,
  Typography,
  TextField,
  Select,
  MenuItem,
  OutlinedInput,
  Switch,
  InputLabel,
  BottomNavigation,
  BottomNavigationAction,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { useRedirect } from "react-admin";
import generateToken from "../../utils/generateToken";
import globalStyles from "../../utils/globalStyles";
import axios from "axios";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useTheme } from "@mui/material/styles";
import legolasApi from "../../api/legolas";
import "../coupon/style.css";
import legolasConfig from "../../api/legolas";

function AddGift(props) {
  const [actionTab, setActiontab] = React.useState(1);
  const { handleSubmit, watch,control,setValue, getValues,formState: { errors }, setError } = useForm({
    defaultValues: {
      maxQtyXAction: "",
      maxQtyYAction: "",
      active: false,
      rule_name: "",
      gift_code: "",
      desc_en: "",
      desc_ar: "",
      onlyforApp: false,
      autoapply: false,
      priority: 0,
      title_en: "",
      title_ar: "",

    },
  });
  const maxQtyXAction = watch('maxQtyXAction');
  const maxQtyYAction = watch('maxQtyYAction');
  const [fromDate, setFromDate] = React.useState(dayjs(new Date()));
  const [toDate, setToDate] = React.useState(dayjs(new Date()));

  const theme = useTheme();
  const [conditionValue, setConditionValue] = React.useState([]);
  const [conditionValueGift, setConditionValueGift] = React.useState([]);
  const [actionValue, setActionValue] = React.useState([]);
  const [skus, setSkusArray] = React.useState([]);
  const [actionSkus, setActionSkuArray] = React.useState([]);
  const [cartSubTotalInclTaxOperator, setCartSubTotalInclTaxOperator] = React.useState('eq');
  const [cartSubTotalInclTax, setCartSubTotalInclTaxValue] = React.useState('0');
  const [toDateError, setToDateError] = React.useState('');
  const [channelData, setChannelData] = React.useState([]);
  const [channelValue, setChannelValue] = React.useState([]);
  const [channelError, setChannelError] = React.useState('');
  const localStorageUser = localStorage.getItem('user');
  const user = JSON.parse(localStorageUser);
  const userid = user.id;
  const userChannels = Array.isArray(user?.channel) ? user.channel.map(String) : [];
  const redirect = useRedirect();
  const [isMultiGift, setIsMultiGift] = React.useState("No");
  const defaultRule = {
    conditionValue: [],
    actionValue: [],
    skus: [],
    actionSkus: [],
    xQty: "",
    yQty: "",
    cartSubTotalInclTaxOperator: "eq",
    cartSubTotalInclTax: "0",
    skuInput: "",
    actionSkuInput: "",
  };

  const [rules, setRules] = React.useState([defaultRule]);
  //const [rules, setRules] = React.useState([{ conditionValue: [],actionValue: [], skus: [], actionSkus: [],cartSubTotalInclTaxOperator: "eq", cartSubTotalInclTax: "0", xQty: "", yQty: "" }]);
  const handleMultiGiftChange = (value) => {
    setIsMultiGift(value);

    if (value === "Yes") {
      setRules([
        { ...defaultRule },
        { ...defaultRule },
      ]);
    } else {
      setRules([{ ...defaultRule }]);
    }
  };

  
  const handleRuleChange = (index, field, value) => {
    setRules(prev =>
      prev.map((rule, i) => {
        if (i !== index) return rule;

        switch (field) {
        case "skuInput": {
  const formatted = value
    .replace(/[,@!%^&*$#| "']+/g, ",")
    .replace(/,+/g, ",");

  return {
    ...rule,
    skuInput: formatted,
    skus: formatted
      ? formatted.split(",").filter(Boolean)
      : [],
  };
}

case "actionSkuInput": {
  const formatted = value
    .replace(/[,@!%^&*$#| "']+/g, ",")
    .replace(/,+/g, ",");

  return {
    ...rule,
    actionSkuInput: formatted,
    actionSkus: formatted
      ? formatted.split(",").filter(Boolean)
      : [],
  };
}
          default:
            return {
              ...rule,
              [field]: value,
            };
        }
      })
    );
  };
  const redirectToList = () => {
    redirect("/gift-cart-rule");
  };
  const handleReset = () => {
    window.location.reload();
  }
  const controllerLabel = {
    margin: "10px 5%",
    fontSize: "20px",
    fontWeight: "bold",
    color: "black",
  };
  const controllerFields = {
    margin: "10px 5%",
    width: "500px",
    borderBottom: "2px solid #2b3f7a",
    borderRadius: 0,
    "& .MuiFilledInput-input": {
      backgroundColor: "#fff !important",
    },
  };

  const controllerSwitch = {
    margin: "10px 5%",
    // width: '500px',
    borderBottom: "2px solid #2b3f7a",
    borderRadius: 0,
    "& .MuiFilledInput-input": {
      backgroundColor: "#fff !important",
    },
  };

  const controllerDropdowns = {
    margin: "10px 5%",
    width: "500px",
    border: "2px solid #2b3f7a",
    borderRadius: 0,
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  function getStyles(name, conditionValue, theme) {
    return {
      fontWeight:
        conditionValue.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }

  const getChannel = () => {
    axios.get(`${legolasApi.url}/admin/channel/list`)
      .then((res) => {
        console.log('order res: ', res.data.data);
        // setChannelData(res.data.data);
        const allChannels = res.data.data;
        const filteredChannels = allChannels.filter(ch => userChannels.includes(ch._id));
        console.log("3", filteredChannels)
        console.log("4", allChannels)

        setChannelData(filteredChannels);
      })
      .catch((error) => console.log('Error in getting channels: ', error));
  };

  React.useEffect(() => {
    getChannel();
  }, [])

  const names = isMultiGift === "Yes"
    ? ["Cart Sub Total (Incl Tax)"]
    : ["Sku", "Cart Sub Total (Incl Tax)"];

  const giftCondition = [
    "Single Gift",
    "Multiple Gifts"
  ]
  const namesAction = [
    "Sku",
  ];

  const saveGift = () => {
    if (channelValue.length === 0) {
      setChannelError("Please select at least one channel");
      return;
    } else {
      setChannelError("");
    }
    let valuesData;
    let data;
    const fieldVals = getValues();
    for (const [index, rule] of rules.entries()) {

      // if (!rule.conditionValue) {
      //   alert(`Rule ${index + 1}: Please select Condition`);
      //   return;
      // }
      if (
        !rule.actionValue ||
        rule.actionValue.length === 0
      ) {
        alert(
          `Rule ${index + 1}: Please select Action`
        );
        return;
      }
      if (rule.conditionValue?.includes("Sku") && (!rule.skus || rule.skus.length === 0)) {
        alert(`Rule ${index + 1}: Please enter SKU`);
        return;
      }

      if (
        rule.actionValue.includes("Sku") &&
        (!rule.actionSkus || rule.actionSkus.length === 0)
      ) {
        alert(`Rule ${index + 1}: Please enter Action SKU`);
        return;
      }
      if (rule.actionValue?.includes("Sku") && rule.actionSkus?.length > 5) {
        alert(`Rule ${index + 1}: Maximum 5 Oracle IDs are allowed`);
        return;
      }
      const isCartSubtotalRule = rule.conditionValue?.includes("Cart Sub Total (Incl Tax)");
      if (!isCartSubtotalRule && !rule.xQty) {
        alert(`Rule ${index + 1}: Please enter Maximum Qty Action X`);
        return;
      }

      if (!rule.yQty) {
        alert(`Rule ${index + 1}: Please enter Maximum Qty Action Y`);
        return;
      }
    }
    if (!fieldVals.title_en?.trim() || !fieldVals.title_ar?.trim()) {
      alert("Please provide both English and Arabic titles");
      return;
    }
    if (!fieldVals.desc_en?.trim() || !fieldVals.desc_ar?.trim()) {
      alert("Please provide both English and Arabic descriptions");
      return;
    }
    let fromdate = Date.parse(fromDate);
    let todate = Date.parse(toDate);
    data = {
      firstname: fieldVals.firstname,
      lastname: fieldVals.lastname,
      email: fieldVals.email,
      allow_login: 1,
      group_id: fieldVals.group,
      website_id: 0,
      dob: dayjs(new Date()) ? dayjs(new Date()) : undefined,
    };
    if (fromdate !== todate) {
      valuesData = {
        giftName: fieldVals.rule_name,
        giftCode: fieldVals.gift_code,
        ruleType: isMultiGift === "Yes" ? "Multiple" : "Single",

        title: {
          "en-SA": fieldVals.title_en,
          "ar-SA": fieldVals.title_ar,
        },
        desc: {
          "en-SA": fieldVals.desc_en,
          "ar-SA": fieldVals.desc_ar,
        },
        active: fieldVals.active,
        onlyforApp: fieldVals.onlyforApp,
        autoapply: fieldVals.autoapply,
        priority: fieldVals.priority,
        giftCondition: {},
        giftValid: {
          fromDate: fromDate,
          toDate: toDate,
        },
        actionRules: {
          xQty: fieldVals.maxQtyXAction,
          yQty: fieldVals.maxQtyYAction,
        },
        conditionRules: {},
        conditions: conditionValue,
        actions: actionValue,
        channels: channelValue,
      };
      setToDateError("");
    } else {
      setToDateError("From Date must be different from To Date");
      return;
    }
    // if (conditionValue.includes("Sku")) {
    //   if (!skus || skus.length === 0) {
    //     return;
    //   } else {
    //     valuesData.conditionRules.sku = {
    //       value: skus,
    //     };
    //   }
    // }
    // if (conditionValue.includes("Cart Sub Total (Incl Tax)")) {
    //   if (cartSubTotalInclTax && cartSubTotalInclTax === '0') {
    //     return;
    //   } else {
    //     valuesData.conditionRules.cartSubTotalInclTax = {
    //       operator: cartSubTotalInclTaxOperator,
    //       value: cartSubTotalInclTax,
    //     };
    //   }
    // }
    // if (actionValue.includes("Sku")) {
    //   if (!actionSkus || actionSkus.length === 0 || actionSkus.length > 5) {
    //     // if (!actionSkus || actionSkus.length < 2 || actionSkus.length > 5) {
    //     return;
    //   } else {
    //     valuesData.actionRules.sku = {
    //       value: actionSkus,
    //     };
    //   }
    // }
    // if (conditionValue.includes("Sku") && fieldVals.maxQtyXAction === "") {
    //   return;
    // }
    // if (conditionValue.includes("Sku") && fieldVals.maxQtyYAction === "") {
    //   return;
    // }

    if (conditionValue.includes("Sku")) {
      if (!conditionValueGift.includes("Single Gift") && !conditionValueGift.includes("Multiple Gifts")) {
        alert("Please select either 'Single Gift' or 'Multiple Gifts'.");
        return;
      }
      if (conditionValueGift.includes("Single Gift")) {
        valuesData.giftCondition.SingleGift = conditionValueGift.includes("Single Gift");
      }
      if (conditionValueGift.includes("Multiple Gifts")) {
        valuesData.giftCondition.multipleGifts = conditionValueGift.includes("Multiple Gifts");
      }
    }

    valuesData.rules = rules.map((rule) => ({
      conditions: Array.isArray(rule.conditionValue)
        ? rule.conditionValue
        : [rule.conditionValue],

      actions: Array.isArray(rule.actionValue)
        ? rule.actionValue
        : [rule.actionValue],

      conditionRules: {
        ...(rule.conditionValue?.includes("Sku") && {
          sku: {
            value: rule.skus || [],
          },
        }),

        ...(rule.conditionValue?.includes("Cart Sub Total (Incl Tax)") && {
          cartSubTotalInclTax: {
            operator: rule.cartSubTotalInclTaxOperator || "eq",
            value: rule.cartSubTotalInclTax || "0",
          },
        }),
      },

      // actionRules: {
      //   ...(rule.actionValue?.includes("Sku") && {
      //     sku: {
      //       value: rule.actionSkus || [],
      //     },
      //   }),

      //   xQty: rule.xQty,
      //   yQty: rule.yQty,
      // },
      actionRules: {
        ...(rule.actionValue?.includes("Sku") && {
          sku: {
            value: rule.actionSkus || [],
          },
        }),

        ...(!rule.conditionValue?.includes(
          "Cart Sub Total (Incl Tax)"
        ) && {
          xQty: rule.xQty,
        }),

        yQty: rule.yQty,
      },
      giftCondition: {
        SingleGift: rule.giftCondition === "Single Gift",
        multipleGifts: rule.giftCondition === "Multiple Gifts",
      },
    }));

    const signedToken = generateToken(data);
    console.log("valuesDatavaluesData", valuesData);
    axios.post(`${legolasConfig.url}/admin/gift/create`, valuesData, {
      headers: {
        Authorization: `Bearer ${signedToken}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        alert("Gift Code Added");
        if (res) {
          redirect("/gift-cart-rule");
        }
      })
      .catch((err) => {
        alert(err.response.data.message);
        console.log(err);
      });
  };

  const handleChange = (event, name) => {
    switch (name) {
      case "fromDate": {
        setFromDate(event);
        break;
      }
      case "toDate": {
        setToDate(event);
        setToDateError("");
        break;
      }
      default:
        break;
    }
  };
  const handleChanges = (event, type, index) => {
    const value = event.target.value;

    switch (type) {
      case "conditionValue":
        updateRule(
          index,
          "conditionValue",
          typeof value === "string" ? value.split(",") : value
        );
        break;

      case "actionValue":
        updateRule(
          index,
          "actionValue",
          typeof value === "string" ? value.split(",") : value
        );
        break;

      default:
        break;
    }
  };
  const handleOperatorChange = (event, name) => {
    const { target: { value } } = event;
    switch (name) {
      case "InclTax": {
        setCartSubTotalInclTaxOperator(value);
        break;
      }
      default:
        break;
    }
  };

  const handleGiftConditionChange = (event, index) => {
    const value = event.target.value;

    updateRule(
      index,
      "giftCondition",
      typeof value === "string"
        ? value.split(",")
        : value
    );
  };

  const handleChannelChanges = (event) => {
    const { target: { value } } = event;
    setChannelValue(value);
  }

  const handleConditionChanges = (value, type) => {
    switch (type) {
      case "sku": {
        const val = value
          .replace(/[,@!%^&*$#| "']+/g, ",")
          .trim(",");

        return val ? val.split(",").filter(Boolean) : [];
      }

      case "actionSku": {
        const val = value
          .replace(/[,@!%^&*$#| "']+/g, ",")
          .trim(",");

        return val ? val.split(",").filter(Boolean) : [];
      }

      default:
        return value;
    }
  };
  const updateRule = (index, key, value) => {
    setRules(prev =>
      prev.map((rule, i) =>
        i === index
          ? { ...rule, [key]: value }
          : rule
      )
    );
  };
  return (
    <React.Fragment>
      <Box
        sx={{
          margin: "30px 50px",
          "& .MuiTypography-root": {
            fontSize: "2.5rem",
            fontWeight: 400,
            color: "#000",
          },
        }}
      >
        <Typography variant="h5">New Gift</Typography>
      </Box>

      <form className={"formClass"} onSubmit={handleSubmit(saveGift)}>
        <Box>
          <BottomNavigation
            showLabels
            value={actionTab}
            onChange={(event, newValue) => {
              setActiontab(newValue);
            }}
            sx={{
              "& .MuiBottomNavigationAction-root": {
                backgroundColor: globalStyles.colors.white,
                border: "2px solid #2b3f7a !important",
                color: "#2b3f7a",
                margin: "5px 10px !important",
                padding: "0 !important",
                fontSize: "0.9rem !important",
                "&:hover": {
                  transform: "scale(1.1, 1.1)",
                },
                "& .Mui-selected": {
                  color: "#2b3f7a",
                  transition: "none",
                  fontSize: "0.9rem",
                },
              },
            }}
          >
            <BottomNavigationAction label="Back" onClick={redirectToList} />
            <BottomNavigationAction label="Reset" onClick={handleReset} />
            <BottomNavigationAction
              label="Save Gift"
              sx={{
                backgroundColor: "#2b3f7a !important",
                border: "2px solid #2b3f7a !important",
                color: "#fff !important",
                "& .Mui-selected": {
                  color: "#fff !important",
                },
              }}
              onClick={saveGift}
              type="submit"
            />
          </BottomNavigation>
        </Box>
        <div>
          <Controller
            name="active"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <div>
                <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                  Active
                </InputLabel>
                <Switch {...field} label="Active" sx={controllerSwitch} />
              </div>
            )}
            sx={{ width: "500px" }}
          />

          <Controller
            name="onlyforApp"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <div>
                <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                  Apply for App
                </InputLabel>
                <Switch {...field} label="Apply for App" sx={controllerSwitch} />
              </div>
            )}
            sx={{ margin: "500px" }}
          />

          <Controller
            name="autoapply"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <div>
                <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                  Auto Apply Complementary Gift
                </InputLabel>
                <Switch {...field} label="Auto Apply Complementary Gift" sx={controllerSwitch} />
              </div>
            )}
            sx={{ margin: "500px" }}
          />

          <Controller
            name="priority"
            control={control}
            defaultValue={0}
            rules={{ required: true }}
            render={({ field }) => (
              <div>
                <InputLabel sx={controllerLabel} id="priority-select-label">
                  Priority
                </InputLabel>
                <Select
                  {...field}
                  labelId="priority-select-label"
                  id="priority-select"
                  label="Priority"
                  sx={controllerDropdowns}
                >
                  {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((value) => (
                    <MenuItem key={value} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            )}
            sx={{ width: "500px" }}
          />
          <Controller
            name="rule_name"
            control={control}
            rules={{ required: "Rule Name is required*" }}
            render={({ field }) => (
              <div>
                <TextField {...field} label=" Gift Rule Name" sx={{ ...controllerFields, paddingBottom: "0px" }} />
              </div>
            )}
            sx={{ margin: "0px 30px" }}
          />
          <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {errors.rule_name && errors.rule_name.message}</span>
          <Controller
            name="gift_code"
            control={control}
            rules={{
              required: "Gift Code is required*",
              validate: (value) => value?.trim() ? true : "Gift Code is required*",
            }}
            render={({ field }) => (
              <div>
                <TextField
                  {...field}
                  onBlur={(e) => {
                    field.onChange(("" + e.target.value).toUpperCase().trim());
                    setValue("gift_code", ("" + e.target.value).toUpperCase().trim(), { shouldValidate: true, shouldDirty: true, });
                    field.onBlur();
                  }}
                  onInput={(e) => e.target.value = ("" + e.target.value).toUpperCase()}
                  label="Gift Code"
                  sx={controllerFields}
                />
              </div>
            )}
            sx={{ margin: "0px 30px" }}
          />
          <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {errors.gift_code && errors.gift_code.message}</span>
          <Controller name="title_en" control={control}
            rules={{ required: "English Title is required" }}
            render={({ field }) => (
              <div>
                <TextField {...field} label="English Title" sx={controllerFields} />
              </div>
            )}
            sx={{ margin: "0px 30px" }}
          />
          <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}>{errors.title_en && errors.title_en.message}</span>
          <Controller name="title_ar" control={control}
            rules={{ required: "Arabic Title is required" }}
            render={({ field }) => (
              <div>
                <TextField {...field} label="Arabic Title"
                  sx={controllerFields}
                />
              </div>
            )}
            sx={{ margin: "0px 30px" }}
          />
          <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}>{errors.title_ar && errors.title_ar.message}</span>
          <Controller
            name="desc_en"
            control={control}
            //rules={{ required:true }}
            rules={{ required: "English Description is required" }}
            render={({ field }) => (
              <div>
                <TextField
                  {...field}
                  label="English Description"
                  sx={controllerFields}
                />
              </div>
            )}
            sx={{ margin: "0px 30px" }}
          />
          <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {errors.desc_en && errors.desc_en.message}</span>
          <Controller
            name="desc_ar"
            control={control}
            //rules={{ required: true }}
            rules={{ required: "Arabic Description is required" }}
            render={({ field }) => (
              <div>
                <TextField
                  {...field}
                  label="Arabic Description"
                  sx={controllerFields}
                />
              </div>
            )}
            sx={{ margin: "0px 30px" }}
          />
          <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {errors.desc_ar && errors.desc_ar.message}</span>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Controller
              name="fromDate"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <DateTimePicker
                  // label="From Date"
                  inputFormat="MM/DD/YYYY , HH:mm:ss"
                  value={fromDate}
                  disablePast
                  onChange={(date) => handleChange(date, "fromDate")}
                  renderInput={(params) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-simple-select-label"
                      >
                        From Date
                      </InputLabel>
                      <TextField {...params} sx={controllerFields} />
                    </div>
                  )}
                />
              )}
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Controller
              name="toDate"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <DateTimePicker
                  inputFormat="MM/DD/YYYY , HH:mm:ss"
                  value={toDate}
                  disablePast
                  minDateTime={fromDate}
                  onChange={(date) => handleChange(date, "toDate")}
                  renderInput={(params) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-simple-select-label"
                      >
                        To Date
                      </InputLabel>
                      <TextField {...params} sx={controllerFields} />
                    </div>
                  )}

                />

              )}
            />
          </LocalizationProvider>
          {toDateError && <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}>{toDateError}</span>}
          <Controller
            name="channel"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <div>
                <InputLabel sx={controllerLabel} id="demo-multiple-name-label">
                  Channel
                </InputLabel>
                <Select
                  labelId="demo-multiple-name-label"
                  id="demo-multiple-name"
                  multiple
                  value={channelValue}
                  onChange={(value) => handleChannelChanges(value)}
                  input={<OutlinedInput label="Name" />}
                  MenuProps={MenuProps}
                  sx={controllerDropdowns}
                >
                  {channelData.map((name) => (
                    <MenuItem key={name._id} value={name._id}>
                      {name.name}
                    </MenuItem>
                  ))}

                </Select>
                {channelValue && channelValue.length === 0 && (
                  <p style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {channelError}</p>
                )}
              </div>

            )}
            sx={{ margin: "0px 30px" }}
          />
          <Controller
            name="isMultiGift"
            control={control}
            defaultValue="No"
            render={() => (
              <div>
                <InputLabel sx={controllerLabel}>
                  Multi Gifts
                </InputLabel>

                <Select
                  value={isMultiGift}
                  onChange={(e) => handleMultiGiftChange(e.target.value)}
                  sx={controllerDropdowns}
                >
                  <MenuItem value="No">No</MenuItem>
                  <MenuItem value="Yes">Yes</MenuItem>
                </Select>
              </div>
            )}
          />

          {rules.map((rule, index) => (
            <React.Fragment key={index}>
              <Controller
                name="conditions"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-multiple-name-label">
                      Condition
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-name-label"
                      id="demo-multiple-name"
                      // multiple
                      //value={conditionValue}
                      //onChange={(value) => handleChanges(value, "conditionValue")}
                      value={rule.conditionValue}
                      onChange={(e) =>
                        handleRuleChange(
                          index,
                          "conditionValue",
                          e.target.value
                        )
                      }
                      input={<OutlinedInput label="Name" />}
                      MenuProps={MenuProps}
                      sx={controllerDropdowns}
                    >
                      {names.map((name) => (
                        <MenuItem
                          key={name}
                          value={name}
                          style={getStyles(name, conditionValue, theme)}
                        >
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              {/* {conditionValue.includes("Sku") ? ( */}
              {rule.conditionValue?.includes("Sku") ? (

                <Controller
                  name="giftConditions"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel sx={controllerLabel} id="demo-multiple-name-label">
                        Select Gift Option
                      </InputLabel>
                      <Select
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        // multiple
                        //value={conditionValueGift}
                        //onChange={(value) => handleGiftConditionChange(value)}
                        value={rule.giftCondition}
                        onChange={(e) =>
                          handleRuleChange(
                            index,
                            "giftCondition",
                            e.target.value
                          )
                        }
                        input={<OutlinedInput label="Name" />}
                        MenuProps={MenuProps}
                        sx={controllerDropdowns}
                      >
                        {giftCondition.map((name) => (
                          <MenuItem
                            key={name}
                            value={name}
                            //style={getStyles(name, conditionValueGift, theme)}
                            style={getStyles(name, [rule.giftCondition], theme)}
                          >
                            {name}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}

              {/* {conditionValue.includes("Sku") ? ( */}
              {rule.conditionValue?.includes("Sku") ? (

                <Controller
                  name="sku"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Enter Comma Seperated Oracle Id
                      </InputLabel>
                      <div>
                        <TextField
                          {...field}
                          //value={skus}
                          //onChange={(value) => handleConditionChanges(value, "sku")}
                          //value={rule.skus ||" "}
                          value={rule.skuInput || ""}
                          onChange={(e) =>
                            handleRuleChange(
                              index,
                              "skuInput",
                              e.target.value
                            )
                          }
                          label="Enter Comma Seperated Oracle Id"
                          sx={controllerDropdowns}
                        // error={Boolean(errors.sku)} 
                        // helperText={errors.sku && errors.sku.message}
                        />
                      </div>
                      {/* {conditionValue.includes("Sku") && skus && skus.length ==0 ? */}
                      {rule.conditionValue?.includes("Sku") && Array.isArray(rule.skus) && rule.skus.length == 0 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}>  Please enter at least one  Oracle Id</span>
                        : null}
                      {rule.conditionValue?.includes("Sku") && Array.isArray(rule.skus) && rule.skus.length > 5 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please add only up to 5 action Oracle Ids</span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {rule.conditionValue.includes("Cart Sub Total (Incl Tax)") ? (
                <Controller
                  name="cartSubTotalInclTax"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Cart Sub Total (Incl Tax)
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        //value={cartSubTotalInclTaxOperator}
                        value={rule.cartSubTotalInclTaxOperator}
                        label="Cart Sub Total (Incl Tax)"
                        //onChange={(value) => handleOperatorChange(value, "InclTax")}
                        onChange={(e) =>
                          handleRuleChange(
                            index,
                            "cartSubTotalInclTaxOperator",
                            e.target.value
                          )
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"eq"}>Eq</MenuItem>
                        <MenuItem value={"gte"}>Gte</MenuItem>
                        <MenuItem value={"lte"}>Lte</MenuItem>
                      </Select>
                      <div>
                        <TextField
                          {...field}
                          //value={cartSubTotalInclTax}
                          value={rule.cartSubTotalInclTax}
                          // onChange={(value) =>
                          //   handleConditionChanges(value, "InclTax")
                          // }
                          onChange={(e) =>
                            handleRuleChange(
                              index,
                              "cartSubTotalInclTax",
                              e.target.value
                            )
                          }
                          label="price"
                          sx={controllerDropdowns}
                        />
                      </div>
                      {rule.conditionValue.includes("Cart Sub Total (Incl Tax)") && rule.cartSubTotalInclTax && rule.cartSubTotalInclTax === "0" ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter Subtotal (Including Tax) value</span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              <Controller
                name="action"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-multiple-name-label">
                      Actions
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-name-label"
                      id="demo-multiple-name"
                      multiple
                      //value={actionValue}
                      //value={rule.actionValue}
                      value={rule.actionValue || []}
                      //onChange={(value) => handleChanges(value, "actionValue")}
                      onChange={(e) =>
                        handleRuleChange(
                          index,
                          "actionValue",
                          e.target.value
                        )
                      }
                      input={<OutlinedInput label="Name" />}
                      MenuProps={MenuProps}
                      sx={controllerDropdowns}
                    >
                      {namesAction.map((name) => (
                        <MenuItem
                          key={name}
                          value={name}
                          style={getStyles(name, actionValue, theme)}
                        >
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              {rule.actionValue?.includes("Sku") ? (
                <Controller
                  name="actionSku"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Enter Comma Seperated Oracle Id
                      </InputLabel>
                      <div>
                        <TextField
                          {...field}
                          //value={actionSkus}
                          value={rule.actionSkuInput || ""}
                          // onChange={(value) =>
                          //   handleConditionChanges(value, "actionSku")
                          // }
                          onChange={(e) =>
                            handleRuleChange(
                              index,
                              "actionSkuInput",
                              e.target.value
                            )
                          }
                          label="Enter Comma Seperated Oracle Id"
                          sx={controllerDropdowns}
                        />
                      </div>
                      {rule.actionValue?.includes("Sku") && Array.isArray(rule.actionSkus) && rule.actionSkus && rule.actionSkus.length === 0 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter at least one action  Oracle Id</span>
                        : null}
                      {rule.actionValue?.includes("Sku") && Array.isArray(rule.actionSkus) && rule.actionSkus.length > 5 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please add only up to 5 action Oracle Ids</span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              <Controller
                name="maxQtyXAction"
                control={control}
                rules={{ required: conditionValue.includes("Sku") }}
                render={({ field }) => (
                  <div>
                    <TextField
                      {...field}
                      value={rule.xQty}
                      onChange={(e) =>
                        handleRuleChange(
                          index,
                          "xQty",
                          e.target.value
                        )
                      }
                      label="Maximum Qty Action X"
                      sx={controllerFields}

                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              {rule.conditionValue?.includes("Sku") && !rule.conditionValue?.includes("Cart Sub Total (Incl Tax)") && (!rule.xQty || rule.xQty === "") && (
                <span style={{ color: "red", marginLeft: "5%", marginTop: '0px', marginBottom: '0px' }}>
                  {'Please enter Maximum Qty Action X'}
                </span>
              )}

              <Controller
                name="maxQtyYAction"
                control={control}
                rules={{ required: conditionValue.includes("Sku") }}
                render={({ field }) => (
                  <div>
                    <TextField
                      {...field}
                      value={rule.yQty}
                      onChange={(e) =>
                        handleRuleChange(
                          index,
                          "yQty",
                          e.target.value
                        )
                      }
                      label="Maximum Qty Action Y"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              {rule.conditionValue?.includes("Sku") && (!rule.yQty || rule.yQty === "") && (
                <span style={{ color: "red", marginLeft: "5%", marginTop: '0px', marginBottom: '0px' }}>
                  {'Please enter Maximum Qty Action Y'}
                </span>
              )}
            </React.Fragment>
          ))}
          <div
            style={{
              width: "100%",
              height: "5px",
              backgroundColor: "black",
              marginTop: "50px",
            }}
          ></div>
        </div>
      </form>
    </React.Fragment>
  );
}

export default AddGift;
